import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPartnerChannel.ts
var t = () => e("partnerChannel");
//#endregion
export { t as useTrPartnerChannel };
